var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"booking__footer"},[_c('a',{staticClass:"text-muted",attrs:{"href":"https://www.smartbooks365.com","target":"_blank"}},[_vm._v(" Powered by "),_c('strong',[_vm._v("Smartbooks")])])])
}]

export { render, staticRenderFns }